import { template as template_01dd604d6c39422480188b04387540fe } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
/**
  Renders a `<td>` element and yields for the developer to supply content.

  ```hbs
  <table.tfoot as |foot|>
    <foot.row as |row|>
      <row.cell>
        Footer content
      </row.cell>
    </foot.row>
  </table.tfoot>
  ```
  @class TFootCell
 */ export default class TFootCell extends Component {
    static{
        template_01dd604d6c39422480188b04387540fe(`
    {{#if this.column.visible}}
      <td class='{{@class}} {{@theme.tfootCell}}' ...attributes>
        {{yield}}
      </td>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @tracked
    index;
    get column() {
        return this.args.columns[this.index];
    }
    constructor(){
        super(...arguments);
        this.index = this.args.parent?.registerCell(this);
    }
    willDestroy() {
        super.willDestroy(...arguments);
        this.args.parent?.unregisterCell(this);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3Rmb290L3Jvdy9jZWxsLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5pbXBvcnQgeyB0cmFja2VkIH0gZnJvbSAnQGdsaW1tZXIvdHJhY2tpbmcnO1xuXG4vKipcbiAgUmVuZGVycyBhIGA8dGQ-YCBlbGVtZW50IGFuZCB5aWVsZHMgZm9yIHRoZSBkZXZlbG9wZXIgdG8gc3VwcGx5IGNvbnRlbnQuXG5cbiAgYGBgaGJzXG4gIDx0YWJsZS50Zm9vdCBhcyB8Zm9vdHw-XG4gICAgPGZvb3Qucm93IGFzIHxyb3d8PlxuICAgICAgPHJvdy5jZWxsPlxuICAgICAgICBGb290ZXIgY29udGVudFxuICAgICAgPC9yb3cuY2VsbD5cbiAgICA8L2Zvb3Qucm93PlxuICA8L3RhYmxlLnRmb290PlxuICBgYGBcbiAgQGNsYXNzIFRGb290Q2VsbFxuICovXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRGb290Q2VsbCBleHRlbmRzIENvbXBvbmVudCB7XG4gIDx0ZW1wbGF0ZT5cbiAgICB7eyNpZiB0aGlzLmNvbHVtbi52aXNpYmxlfX1cbiAgICAgIDx0ZCBjbGFzcz0ne3tAY2xhc3N9fSB7e0B0aGVtZS50Zm9vdENlbGx9fScgLi4uYXR0cmlidXRlcz5cbiAgICAgICAge3t5aWVsZH19XG4gICAgICA8L3RkPlxuICAgIHt7L2lmfX1cbiAgPC90ZW1wbGF0ZT5cblxuICBAdHJhY2tlZFxuICBpbmRleDtcblxuICBnZXQgY29sdW1uKCkge1xuICAgIHJldHVybiB0aGlzLmFyZ3MuY29sdW1uc1t0aGlzLmluZGV4XTtcbiAgfVxuXG4gIGNvbnN0cnVjdG9yKCkge1xuICAgIHN1cGVyKC4uLmFyZ3VtZW50cyk7XG5cbiAgICB0aGlzLmluZGV4ID0gdGhpcy5hcmdzLnBhcmVudD8ucmVnaXN0ZXJDZWxsKHRoaXMpO1xuICB9XG5cbiAgd2lsbERlc3Ryb3koKSB7XG4gICAgc3VwZXIud2lsbERlc3Ryb3koLi4uYXJndW1lbnRzKTtcbiAgICB0aGlzLmFyZ3MucGFyZW50Py51bnJlZ2lzdGVyQ2VsbCh0aGlzKTtcbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBQzNDLFNBQVMsT0FBTyxRQUFRLG9CQUFvQjtBQUU1Qzs7Ozs7Ozs7Ozs7OztDQWFDLEdBRUQsZUFBZSxNQUFNLGtCQUFrQjtJQUNyQyxNQUFBO1FBQUEsMENBQVUsQ0FBQTs7Ozs7O0VBTVYsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBTkE7SUFRVixDQUFDO0lBQ0QsTUFBTTtJQUVOLElBQUksU0FBUztRQUNYLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztJQUN0QztJQUVBLGFBQWM7UUFDWixLQUFLLElBQUk7UUFFVCxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLGFBQWEsSUFBSTtJQUNsRDtJQUVBLGNBQWM7UUFDWixLQUFLLENBQUMsZUFBZTtRQUNyQixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxlQUFlLElBQUk7SUFDdkM7QUFDRiJ9